export const configConstants = {
  CONFIG_LOAD: '[Config] Load',
  CONFIG_LOAD_SUCCESS: '[Config] Load success',
  CONFIG_LOAD_FAILURE: '[Config] Load failure',
  CONFIG_RESET: '[Config] Reset',
  CONFIG_RENDER_SUCCESS: '[Config] Render success'
}
